$('body').on('click', '.js-accordion-head', function() {
	$(this)
		.next('.js-accordion-body')
		.slideToggle(150)
		.toggleClass('active');
	$(this).toggleClass('active');
});
